import { FC, Fragment, useReducer } from 'react';

import { CalendarCog } from 'lucide-react';

import Button from '@mui/material/Button';

import { ScheduleBalanceDistributionDialog } from './scheduleBalanceDistributionDialog/ScheduleBalanceDistributionDialog';

export const ScheduleBalanceDistributionButton: FC = () => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<CalendarCog width={22} height={22} />} variant="outlined" size="large">
        Schedule Balance Distribution
      </Button>

      <ScheduleBalanceDistributionDialog isOpen={isOpen} onClose={setOpen} />
    </Fragment>
  );
};
